module.exports = __webpack_public_path__ + "static/media/Acheive4.4c5c6afb.jpg";